<!----------------------- Компонент вводу пароля користувача --------------------->
<template>
    <smallModal @escape="$emit('close')">
        <div>
            <div class="usr-icon-login-container">
                <div class="user-icon-div">
                    <div class="circle-avatar">
                        <div data-v-01c4cbed="">
                            <div data-v-3b0aa6a6="">
                                <svg data-v-3b0aa6a6="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                    fill="none" stroke="#00c279" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="icon icon-tabler icons-tabler-outline icon-tabler-user"
                                    style="width: 67px;height: 67px;">
                                    <path data-v-3b0aa6a6="" stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path data-v-3b0aa6a6="" d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                                    <path data-v-3b0aa6a6="" d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <hr> -->
            <div class="form">
                <div>
                    <div>
                        <label for="login" class="enter-text" v-html="lang['EMailOrPhone']"></label>
                        <b-form-input type="email" v-model="form.login" :state="loginState" id="login" ref="loginInput"
                            class="input" :placeholder="lang['LoginPlaceholder']" />
                    </div>

                    <div class="password">
                        <label for="password">{{ lang['Password'] }}</label>
                        <b-form-input type="password" v-model="form.password" :state="statePass" id="password"
                            autofocus />
                        <span v-if="form.password.length > 0" @click="showPass"
                            :class="visiblePass ? 'icon-eye' : 'icon-eye-blocked'"></span>
                    </div>
                </div>
            </div>
            <hr>
            <div class="buttons" :style="w > 700 && !registered ? { 'max-width': ' 370px' } : { 'width': '' }">
                <button class="btn enterButton" @click="save">{{ lang['EnterToCompany'] }}</button>
            </div>
        </div>
    </smallModal>
</template>

<script>
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import smallModal from '../modals/smallModal'; // Компонент маленького модального вікна
import { store } from '@/store.js' // Глобальне сховище даних
import Cookies from 'js-cookie' // Модуль для роботи з кукі
import { Auth } from '@/API_auth.js'; // Апі для роботи з авторизацією
let apiService = new Auth(); // Підключення апі авторизакції

export default {
    props: ['registered'],
    components: {
        smallModal
    },
    data() {
        return {
            form: {
                login: '',
                password: ''
            },
            visiblePass: false,
        }
    },
    mounted() {
        keyevent.$off('enter');
        keyevent.$on('enter', () => {
            if (this.registered) {
                this.statePass ? this.save() : window.say.messageError(this.lang['MinPassLength'])
            }
        })
    },
    beforeDestroy() {
        keyevent.$off('enter');  // очищуємо перед знищенням компонента
    },
    methods: {
        cancel() {
            keyevent.$off('enter');
            this.$emit('close')
        },

        loginDev(loginData) {
            return new Promise((resolve, reject) => {
                apiService.loginInCabinet(loginData).then(json => {
                    if (json.status == "done") {
                        if (json.data.token) {
                            let token = json.data.token
                            Cookies.set(`token`, token);
                            store.token = token;
                            resolve(true)
                        } else {
                            // Якщо пройшла авторизація не успішно, тоді будемо
                            // передавати дані про кількість спроб, що залишилися, на спроби входу
                            if (json.data.countsLeft > 0) {
                                window.say.messageError(this.lang['InvalidPassNumberOfAttemptsToCheckAuth'] + ' ' + json.data.countsLeft);
                            }
                            // Якщо пройшла авторизація не успішно, тоді будемо
                            // передавати дані про кількість спроб, що залишилися, на спроби входу
                            if (!json.data.canAuth) {
                                window.say.messageError(this.lang['TryAgainAfterMinute']);
                            }
                        }
                    } else {
                        if (json.error[0] == "login is incorrect") {
                            window.say.messageError(this.lang['WrongLoginOrPassword']);
                        } else if (json.error[0] == "pass is incorrect") {
                            window.say.messageError(this.lang['WrongLoginOrPassword']);
                        } else if (json.error[0] == "wrong terminal password") {
                            window.say.messageError(this.lang['WrongLoginOrPassword']);
                        } else {
                            window.say.messageError(this.lang['Error']);
                        }
                    }
                }).catch(err => {
                    console.error(err);
                    window.say.messageError(this.lang['Error']);
                    reject()
                });
            })
        },
        // Беремо паролі при натисканні на кнопку та відправляємо його в батька, там викликаємо функцію логіна
        async save() {
            if (this.statePass && this.loginState) {
                const res = await this.loginDev(this.form)
                if (res) {
                    this.$emit('success')
                }
            } else {
                if (!this.statePass) {
                    window.say.messageError(this.lang['MinPassLength']);
                }
                if (!this.loginState) {
                    window.say.messageError(this.lang['EMailOrPhoneNumber']);
                }
            }
        },
        showPass() {
            this.visiblePass = !this.visiblePass
            const input = document.getElementById('password');
            if (input.getAttribute('type') == 'password') {
                input.setAttribute('type', 'text');
            } else {
                input.setAttribute('type', 'password');
            }
        },
    },
    computed: {
        loginState() {
            return this.form.login != '' && this.form.login.length >= 4 ? true : false;
        },
        statePass() {
            return this.form.password.length >= 4 ? true : false;
        },
        // Мова додатку
        lang() {
            return window.lang;
        },
        w() {
            return store.window.width;
        }
    }
}
</script>

<style scoped>
.btn {
    width: 49%;
}

.btn-success {
    border: none;
}

/* .form {
  margin-bottom: 30px;
} */

.buttons {
    display: flex;
    justify-content: space-between;
}

.forgot-password {
    text-align: right;
    color: #007bff;
    text-decoration: underline;
    cursor: pointer;
}

.form-control.is-valid {
    background-image: none;
    border-color: #00C279;
}

.usr-icon-login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 20px;
}

.account-icon {
    height: 3rem;
}

.user-icon-div {
    /* border: 1px solid gray; */
    /* width: 4rem;
  height: 4rem; */
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-radius: 999px;
    margin-bottom: 1rem;
}

.circle-avatar {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 5px solid #00c279;
}

.person-login[data-v-01c4cbed] {
    color: #696969;
}

.notExistH {
    color: grey;
    text-align: center;
}

.person-login {
    font-size: 1.3rem;
    font-weight: 500;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
}

label {
    /* font-family: 'Montserrat'; */
}

.icon-eye,
.icon-eye-blocked {
    position: absolute;
    right: 12.5%;
    top: 58.5%;
    cursor: pointer;
}

.btn-go-reg {
    text-transform: uppercase;
    font-size: 10pt;
    background-color: #00C279;
}

.cancelButton {
    /* text-align:left; */
    text-transform: uppercase;
    font-size: 10pt;
    color: gray
}

.enterButton {
    text-transform: uppercase;
    font-size: 10pt;
    background-color: #00C279;
    color: white;
    width: 100%;
}

@media screen and (max-width: 700px) {
    .btn-go-reg {
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.password {
    position: relative;
}

input[type="password"]::-ms-reveal {
    display: none;
}

.form-control.is-valid,
.form-control.is-valid:focus {
    border-color: #00c279;
}

.form-control.is-valid {
    border-color: #00c279;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid,
.form-control.is-invalid:focus {
    border-color: #ff3548;
}

.form-control.is-invalid {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}
</style>